<template>
	<div class="margin-left flex-sub">
		<div v-if="total != 0">
			<div v-for="(item,indx) in list" :key="indx">
				<StationList :data="item" :width="920" :height="184" :size="24"></StationList>
			</div>
			<div class="pagination">
				<el-pagination
				@current-change="handleCurrentChange"
				  background
				  layout="prev, pager, next"
				  prev-text="上一页"
				  next-text="下一页"
				  :total="total">
				</el-pagination>
			</div>
		</div>
		<div class="text-center" v-else>
			<el-empty description="暂无数据"></el-empty>
		</div>
	</div>
</template>

<script>
	// 谁看过我的找活
	import StationList from './station-list.vue';
	export default {
		components: {
			StationList
		},
		name: '',
		data() {
			return {
				page:1,
				list:[],
				total:0,//
			}
		},
		created() {
			this.getlist()
		},
		methods: {
			handleCurrentChange: function(currentPage) {
			  this.page = currentPage;
			  this.getlist();
			},
			getlist(){
				this.ajax('get', '/api/pc/browse/getBrowseList', {
					type:1,
					page:this.page,
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.list = res.data.data
						if(this.page == 1){
							this.total =  Number(res.data.lastpage) * Number(res.data.data.length)
						}
					}else{
						this.$message(res.msg);
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.pro-item:hover{
		color: #09827B;
	}
	/deep/ .el-pagination.is-background .btn-next,/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .el-pager li{
		background: #fff !important;
	}
	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
		background:#09827B !important;
		color: #fff !important;
	}
	/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .btn-next{
		padding: 0 10px;
	}
	
	.pagination{
		margin: 59px 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/seen/worker.vue